<template>
  <div
    v-if="!props.cell.hide"
    class="cell"
    :style="{width: props.cell.width + 'px', 'min-width': props.cell.minWidth + 'px'}"
    @click="handelCellClick($event)"
    @mouseenter="isHeaderCellHovered = true"
    @mouseleave="isHeaderCellHovered = false"
  >
    <div
      v-if="slots.selector"
      class="selector"
    >
      <slot name="selector" />
    </div>
    <div
      ref="title"
      class="title"
    >
      <slot name="title" />
    </div>

    <div
      class="drag"
      :class="{active: state.dragging }"
      @mousedown="startDrag($event)"
      @mousemove="drag($event)"
      @mouseup="stopDrag($event)"
      @click.stop
    />
    <button
      class="icon"
      @click.stop="hideCol()"
    >
      <Transition>
        <i
          v-if="isHeaderCellHovered"
          class="icon-eye-off"
        />
      </Transition>
    </button>
    <div
      v-if="cell.useSort"
      v-click-outside="() => isShowSorting = false"
      class="sort"
      @click.self="isShowSorting = !isShowSorting"
    >
      <svg
        v-if="isHeaderCellHovered"
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click.self="isShowSorting = !isShowSorting"
      >
        <path
          d="M1.3335 11.5H9.66683M1.3335 6.5L14.6668 6.5M1.3335 1.5L6.3335 1.5"
          stroke="#373D3F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <SortingBox
        :key="props.currentSortingColumn"
        :current-column="props.cell.name"
        :current-sorting-column="props.currentSortingColumn"
        :current-sorting-order="props.currentSortingOrder"
        :is-show-sorting="isShowSorting"
        @change-sorting="args => emit('change-sorting-column', args)"
      />
    </div>
  </div>
</template>

<script setup>
import {defineProps, reactive, defineEmits, ref, watch, useSlots} from "vue";
import SortingBox from "@/components/table/HeaderCell/SortingBox.vue";

const props = defineProps({
  cell: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required: true
  },
  currentSortingColumn: {
    type: [String, null],
    required: true,
    default: () => null
  },
  currentSortingOrder: {
    type: String,
    required: true,
    default: () => "asc"
  },
  columnList: {
    type: Array,
    required: true
  }
});

const localList = ref([...props.columnList]);
watch(
    () => props.columnList,
    (newVal) => {
      localList.value = [...newVal];
    }
);

const isShowSorting = ref(false);

const isHeaderCellHovered = ref(false);

const slots = useSlots();

const emit = defineEmits("activeCellsInCol", "update-column-width");

let state = reactive({
  startX: null,
  dragging: false,
  initialWidth: null,
});

const startDrag = (event) => {
  if(props.cell) {
    state.startX = event.clientX;
    state.dragging = true;
    state.initialWidth = parseFloat(localList.value[props.index].width);
  }
};

const drag = (event) => {
  if (state.dragging && props.cell) {
    const deltaX = event.clientX - state.startX;
    const newWidth = state.initialWidth + deltaX;
    localList.value[props.index].width = newWidth > props.cell.minWidth ? newWidth : props.cell.minWidth;
    emit("update-column-width", localList.value);
  }
};

const stopDrag = () => {
  state.dragging = false;
  state.startX = null;
  state.initialWidth = null;
};

const hideCol = () => {
  const column = props.columnList.find(header => header.name === props.cell.name);
  if (column) {
    column.hide = !column.hide;
  }
};

const handelCellClick = (event) => {
  const target = event.target;

  if(target.classList.contains("icon-filter")) {
    return;
  }

  emit("activeCellsInCol", props.index);
};

</script>

<style lang="scss" scoped>

.sort {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  min-height: 32px;
  border-radius: 100%;

  &:hover {
    background: #FFFFFF;
  }
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  min-height: 32px;
  border-radius: 100%;
  transition: background-color ease-in-out 0.3s;

  &:hover {
    background: #FFFFFF;
  }
}

.cell {
  &:hover {
    & .hidden {
      opacity: 1;
    }
  }
}

.hidden {
  opacity: 0;
  transition: opacity .1s;
  position: absolute;
  right: 65px;
  color: #7B87A5;
  &.showed {
    opacity: 1;
  }
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  color: #7B87A5;;
}

.filter {
  position: absolute;
  right: 80%;
  top: 100%;
  z-index: 1;
}



.drag {
  position: absolute;
  // background: red;
  height: 100%;
  width: 5px;
  top: 0;
  right: 0;
  cursor: e-resize;
  z-index: 1;
  &.active {
    position: fixed;
    width: 100%;
    height: 100%;
    background: transparent;
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>